import { gtcTransitionEnd, gtcRemoveTransitionEnd, gtcScrollLock, gtcScrollUnlock, gtcSetPreviousFocus, gtcTrapFocus, gtcRemoveTrapFocus } from 'gtcUtils';



/* Custom Mobile Navigation */

const customMobileNavTrigger = class CustomMobileNavTrigger extends HTMLElement {
    constructor() {
        super();

        this.Click = this.Click.bind(this);
        this.Keydown = this.Keydown.bind(this);
    }

    connectedCallback() {
        if (!this.hasAttribute('tabindex')) {
            this.setAttribute('tabindex', 0);
        }
        this.AddEventListeners();
    }

    disconnectedCallback() {
        this.RemoveEventlisterners();
    }

    AddEventListeners() {
        this.addEventListener('click', this.Click, false);
        this.addEventListener("keydown", this.Keydown, false);
    }

    RemoveEventlisterners() {
        this.removeEventListener('click', this.Click, false);
        this.removeEventListener("keydown", this.Keydown, false);
    }

    Keydown(event) {
        if (event.key === 'Enter') {
            this.Click();
        }
    }

    Click() {
        if (this.hasAttribute('aria-controls')) {
            gtcSetPreviousFocus(this);
            const target = document.getElementById(this.getAttribute('aria-controls'));
            if (target) {
                if (target.hasAttribute('open')) {
                    target.removeAttribute('open');
                    document.body.classList.remove('custom-nav-open');
                    gtcRemoveTrapFocus(target);
                }
                else {
                    target.setAttribute('open', '');
                    document.body.classList.add('custom-nav-open');
                    gtcTrapFocus(target);
                }
            } else {
                this.RemoveEventlisterners();
                this.setAttribute('disabled', '');
                console.warn('No target found with ID: ' + this.getAttribute('aria-controls'));
            }
        }
    }
};
if (!window.customElements.get("custom-mobile-nav-trigger")) {
    window.customElements.define("custom-mobile-nav-trigger", customMobileNavTrigger);
}


const customMobileNav = class CustomMobileNav extends HTMLElement {

    static observedAttributes = ["open"];

    constructor() {
        super();

        //Default classes
        this.class = {
            open: 'open',
            close: 'close',
            overlayOpen: 'gtc:overlay-open',
            scrollLock: 'gtc:scroll-lock'
        }

        this.Click = this.Click.bind(this);
        this.Keydown = this.Keydown.bind(this);
    }


    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "open") {
            if (newValue !== null) {
                this.Open();
                this.setAttribute('aria-hidden', "false");

            } else {
                this.Close();
                this.setAttribute('aria-hidden', "true");
            }
        }
    }

    get isOpen() {
        return this.getAttribute("open") === "true";
    }
    set isOpen(value) {
        this.setAttribute("open", value ? "true" : "false");
    }

    connectedCallback() {
        if (!this.hasAttribute('tabindex')) {
            this.setAttribute('tabindex', 0);
        }
    }

    disconnectedCallback() {
        this.RemoveEventlisterners();
    }

    AddEventListeners() {
        document.addEventListener('click', this.Click, false);
        document.addEventListener("keydown", this.Keydown, false);
    }

    RemoveEventlisterners() {
        document.removeEventListener('click', this.Click, false);
        document.removeEventListener("keydown", this.Keydown, false);
    }

    Keydown(event) {
        // If Esc key
        if (event.keyCode !== 27) return;
        this.removeAttribute(this.class.open);
    }

    Click(event) {
        const target = event.target;

        if (this.contains(target) && !target.closest('.custom-drawer__overlay')) {
            return;
        }
        this.removeAttribute(this.class.open);
    }

    Open() {
        gtcRemoveTransitionEnd(this);
        this.style.display = 'block';
        document.documentElement.style.setProperty('--custom-nav-offset', this.getBoundingClientRect().top + 'px')
        gtcScrollLock([this.class.scrollLock, this.class.overlayOpen, 'custom-nav-open']);
        this.tabIndex = 0;
        requestAnimationFrame(() => {
            gtcTrapFocus(this);
            this.AddEventListeners()
        });
    }

    Close() {
        gtcTransitionEnd(this, () => {
            this.style.display = 'none';
        });

        this.removeAttribute(this.class.open);
        this.tabIndex = -1;

        requestAnimationFrame(() => {
            this.RemoveEventlisterners();
        });

        gtcScrollUnlock([this.class.scrollLock, this.class.overlayOpen, 'custom-nav-open']);
        gtcRemoveTrapFocus(this);
    }
};

if (!window.customElements.get("custom-mobile-nav")) {
    window.customElements.define("custom-mobile-nav", customMobileNav);
}